var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43559_78623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5.0013L9.99999 1.66797M9.99999 1.66797L6.66666 5.0013M9.99999 1.66797V8.33464",
    stroke: "#572148",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 11.668H3.33332C2.41285 11.668 1.66666 12.4142 1.66666 13.3346V16.668C1.66666 17.5884 2.41285 18.3346 3.33332 18.3346H16.6667C17.5871 18.3346 18.3333 17.5884 18.3333 16.668V13.3346C18.3333 12.4142 17.5871 11.668 16.6667 11.668Z",
    stroke: "#572148",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15H5.00833M8.33333 15H8.34167",
    stroke: "#572148",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43559_78623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetCode);
export default __webpack_public_path__ + "static/media/DET-Code.cabc3777878f80aafa22aa38fa6fe439.svg";
export { ForwardRef as ReactComponent };